import { useConnections } from '@solfacil/plasma-utils';
import { HttpResponse, http } from 'msw';

import MockBuilder from '~/apis/mocks/MockBuilder';
import type { User } from '~/types/ecommerce/generated.codegen';

export default (() => {
  function baseApi(path?: string) {
    return `${useConnections().rest.ecommerce.url}${path || ''}`;
  }

  return [
    http.get(baseApi(), () => {
      return HttpResponse.json(new MockBuilder().rest().get<User>('user'));
    }),
  ];
})();
